"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InfoBarEpic = void 0;
var _reduxObservable = require("redux-observable");
var _rxjs = require("rxjs");
var _operators = require("rxjs/operators");
var _types = require("../blitz/types");
var _types2 = require("../game/types");
var _types3 = require("./types");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var InfoBarEpic = exports.InfoBarEpic = /*#__PURE__*/_createClass(function InfoBarEpic() {
  var _this = this;
  _classCallCheck(this, InfoBarEpic);
  _defineProperty(this, "getEpic", function () {
    return (0, _reduxObservable.combineEpics)(_this.onUnfinishedFeature, _this.onRoundEnd, _this.onRoundStart, _this.onStopping);
  });
  _defineProperty(this, "onUnfinishedFeature", function (action$, store) {
    return action$.pipe((0, _reduxObservable.ofType)(_types2.UNFINISHED_FEATURE),
    //  filter(a => store.value.infoBar.state == GameInfoBarState.Reconnect),
    (0, _operators.mapTo)({
      type: _types3.IB_SET_STATE,
      payload: _types3.GameInfoBarState.Reconnect
    }));
  });
  /**
   * 
   * @param action$
   * @param store
   */
  _defineProperty(this, "onRoundEnd", function (action$, store) {
    return action$.pipe((0, _reduxObservable.ofType)(_types2.ROUND_END), (0, _operators.mergeMap)(function () {
      // there was no win or feature triggering, so basically round ended while running was active.
      if (store.value.infoBar.state === _types3.GameInfoBarState.Started || store.value.infoBar.state === _types3.GameInfoBarState.Empty) {
        var actions = [];
        if (!store.value.game.hyperSpin) actions.push((0, _rxjs.of)({
          type: _types3.IB_SET_STATE,
          payload: _types3.GameInfoBarState.Ended
        }));
        // if empty to idle timeout, set, do that. basically isntead of showing empty after a none winning round for
        // disconnected from IDLE action used in other places
        if (store.value.infoBar.settings.idleTimeout) {
          actions.push((0, _rxjs.of)({
            type: _types3.IB_SET_STATE,
            payload: _types3.GameInfoBarState.Idle
          }).pipe((0, _operators.delay)(store.value.infoBar.settings.idleTimeout), (0, _operators.takeUntil)(action$.pipe((0, _reduxObservable.ofType)(_types2.ROUND_START, _types.BLITZ_MODE_ON)))));
        }
        return _rxjs.concat.apply(void 0, actions);
      } else if (store.value.infoBar.state === _types3.GameInfoBarState.Win && store.value.infoBar.settings.winIdleTimeout) {
        return (0, _rxjs.of)({
          type: _types3.IB_SET_STATE,
          payload: _types3.GameInfoBarState.Idle
        }).pipe((0, _operators.delay)(store.value.infoBar.settings.winIdleTimeout), (0, _operators.takeUntil)(action$.pipe((0, _reduxObservable.ofType)(_types2.ROUND_START, _types.BLITZ_MODE_ON))));
      }
      return _rxjs.EMPTY;
    }));
  });
  /**
  * 
  * @param action$
  * @param store
  */
  _defineProperty(this, "onRoundStart", function (action$, store) {
    return action$.pipe((0, _reduxObservable.ofType)(_types2.ROUND_START), (0, _operators.mergeMap)(function (a) {
      // this round start was called from a blitz feature where player choose to play classic.
      // dont reset the info bar state to started and show gl.
      if (a.payload == 'blitzPlayClassic') return _rxjs.EMPTY;
      if (store.value.game.hyperSpin) return (0, _rxjs.of)({
        type: _types3.IB_SET_STATE,
        payload: _types3.GameInfoBarState.Empty
      });
      return (0, _rxjs.of)({
        type: _types3.IB_SET_STATE,
        payload: _types3.GameInfoBarState.Started
      });
    }));
  });
  _defineProperty(this, "onStopping", function (action$, store) {
    return action$.pipe((0, _reduxObservable.ofType)(_types3.IB_STOPPING), (0, _operators.filter)(function (a) {
      return store.value.infoBar.state == _types3.GameInfoBarState.Started;
    }), (0, _operators.mapTo)({
      type: _types3.IB_SET_STATE,
      payload: _types3.GameInfoBarState.Empty
    }));
  });
});
//# sourceMappingURL=epics.js.map